import { render, staticRenderFns } from "./healthInsOrder.vue?vue&type=template&id=a737849e&scoped=true&"
import script from "./healthInsOrder.vue?vue&type=script&lang=js&"
export * from "./healthInsOrder.vue?vue&type=script&lang=js&"
import style0 from "./healthInsOrder.vue?vue&type=style&index=0&id=a737849e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a737849e",
  null
  
)

export default component.exports